import { useToast } from "@/components/ui/use-toast";
import { Copy } from "lucide-react";
import { FC } from "react";

type CopyToClipBoardBtnProps = {
  val: string;
  id: string;
  className: string;
};

const CopyToClipBoardBtn: FC<CopyToClipBoardBtnProps> = ({
  val,
  id,
  className
}) => {
  const { toast } = useToast();
  const copyToClipBoard = async (val: string) => {
    try {
      await navigator.clipboard.writeText(val);
      toast({
        description: "Copied to clipboard!"
      });
    } catch (err) {
      toast({
        description: "Failed to copy!!",
        variant: "destructive"
      });
      console.error("Failed to copy: ", err);
    }
  };
  return (
    <div title="Copy to clipboard">
      <Copy
        className={className}
        id={id}
        onClick={() => copyToClipBoard(val)}
      />
    </div>
  );
};

export default CopyToClipBoardBtn;
